import { EModelApiPaths } from "../app/enums/EModelApiPaths";

export const environment = {
    // PB_BE_HOST_PORT: 'https://dev.pb.be.blueoceanint.com',
    PB_BE_HOST_PORT: 'https://niyati.dev.be.savaapi.com',
    USER_PATH: 'adminniyati',
    // PB_BE_WS_HOST_PORT: 'https://dev.pb.ws.blueoceanint.com',
    production: false,
    INS: 'mongodb',
    DB: 'phone_book',
    authTokenInfo: 'niyati_authorization', // it will be secret path.
    IS_ENCRYPTED: false,
    ENV: 'DEV', // DEV | QA | PROD
    BUCKET_NAME: 'wms-dev-env',
    FILE_PATH: 'pb-dev',
    TRAINER_RESUME_PATH: '/resumes/trainer',

    pi: { // here pi means Project Identifier
       "localhost:7879": "admin@worshipearth.in",
    },

    crypto: {
        passJWT: 'dbec4c8c-8dd3-488e-b845-0e708400d4b5', // dev server
    },

    PB_BE_HOST_PORT_PRINT: 'https://pb.dev.admin.savaapi.com',

    get PB_BE_HOST_PORT_SITES() {
        return this.PB_BE_HOST_PORT + `${EModelApiPaths.API}`;
    },
};
